<!--食堂 -->
<template>
    <div id="software">
        <section class="grey">
            <div class="head-introduce">
                <div class="intr-left">
                    <img src="@/assets/images/softwareproducts/soft-c-0.png" />
                    <span class="titleb span1">食堂管理系统</span>
                </div>
                <div class="intr-right">
                    <span class="titleg">概述</span>
                    <span class="titleb span2">功能特色</span>
                </div>
            </div>
            <div class="head-contain" data-am-scrollspy="{animation: 'fade'}">
                <h1 class="p1">食堂管理系统</h1>
                <p class="p2">
                    利用物联网、人工智能等技术手段和装备，从人、物、菜三个方面实现对食堂运营的智能化管理，
                    实现食品材料入库、粗加工、切配、烹饪、留样、出餐、餐饮具清洗消毒、废弃物管理等关键环节和
                    重点区域场所的信息化、可视化管理；并且针对校园食品安全管理规定设置了特色功能，更加适合学校
                    食堂应用。促使食堂进一步增强自律意识，规范操作行为。
                </p>
                <img src="@/assets/images/softwareproducts/soft-c-1.png" />
            </div>
        </section>
        <section class="white">
            <div class="product">
                <p class="p1">产品特色</p>
                <ul class="ul">
                    <li data-am-scrollspy="{animation: 'fade'}">
                        <img src="@/assets/images/softwareproducts/soft-c-2.png" />
                        <div class="title">
                            <p>全程信息化</p>
                            <span>
                                实现对人员、晨检、收货、农残快检、仓库、就餐、<br>
                                陪餐、消毒等的全流程信息化管理。
                            </span>
                        </div>
                    </li>
                    <li data-am-scrollspy="{animation: 'fade'}">
                        <img src="@/assets/images/softwareproducts/soft-c-3.png" />
                        <div class="title">
                            <p>AI智能分析</p>
                            <span>AI视觉人工智能技术，可以自动分析视频监控中的多种违规操
                                作，并自动抓拍、报警、留证。</span>
                        </div>
                    </li>
                    <li data-am-scrollspy="{animation: 'fade'}">
                        <img src="@/assets/images/softwareproducts/soft-c-4.png" />
                        <div class="title">
                            <p>自动预警</p>
                            <span>
                                智能化设备自动获取的业务数据，经过<br>
                                数据分析后对可能存在的管理、安全<br>
                                问题及时作出预警提示。
                            </span>
                        </div>
                    </li>
                    <li data-am-scrollspy="{animation: 'fade'}">
                        <img src="@/assets/images/softwareproducts/soft-c-5.png" />
                        <div class="title">
                            <p>校园定制</p>
                            <span>针对于国家关于校园食品安全管理规定，优化定制了陪餐、营养健康分析等功能。</span>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="grey">
            <div class="func" data-am-scrollspy="{animation: 'fade'}">
                <p class="p1">主要功能</p>
                <div class="contain h800">
                    <img src="@/assets/images/softwareproducts/soft-c-6.png" />
                    <ul class="func-ul">
                        <li v-for="(item,index) in funcList" :key="index">
                            <p>{{item.title}}</p>
                            <span>{{item.content}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="white">
            <div class="app-c">
                <p class="p1">应用场景</p>
                <ul class="contain">
                    <li>
                        <div class="c-img">
                            <img src="@/assets/images/softwareproducts/soft-c-7.png" />
                        </div>
                        <div class="content">
                            <p>餐饮企业-精细化管理</p>
                            <span>
                                以较低的成本投入，快速提升食堂的运营管理水平，在无感情况下实现对各项运营数据、
                                指标的收集分析，为企业决策管理提供数据支撑
                            </span>
                            <span>
                                同时信息化、智能化装备大大减轻工作负担，提高工作效率。如利用智能电子秤不仅可以提高工作效率，
                                更能减少人为失识；AI智能监控分析，可以随时自动抓取违规操作，提升监管效率。
                            </span>
                        </div>
                    </li>
                    <li>
                        <div class="c-img">
                            <img src="@/assets/images/softwareproducts/soft-c-8.png" />
                        </div>
                        <div class="content">
                            <p>区域监管-食品安全监管</p>
                            <span>对智能化的装备自动获取的数据进行分析，可让监管部门直观了解辖区内食堂运营情况，对可能存在的食品安全风险进行评估并预警，防范于未然。 </span>
                            <span>同时出现食品安全事故时，可快速定位问题源头，采取必要措施。</span>
                            <span>远程巡检、云端溯源等手段可帮助监管部门大大减轻工作负担。</span>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="grey">
            <div class="recommended_general">
                <p class="p1">推荐产品</p>
                <div v-if="!$utils.isArrayEmpty(recommProductsList)" class="recommended_general_content">
                    <router-link v-for="(item,index) in recommProductsList" :to="item.routeUrl||''" :key="index" class="recommended_general_item">
                        <i v-if="$utils.isNoNullAll(item.icon)" :class="item.icon"></i>
                        <span class="text">{{item.name}}</span>
                    </router-link>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import generalConfig from "config/general.config.js";
import $ from 'jquery'
import metaInfoUtils from 'config/metaInfo.config.js';

export default {
    metaInfo: metaInfoUtils.currentMetaInfo('/softwareproducts/canteen'),
    data(){
        return{
            recommProductsList:generalConfig.recommProductsList,//推荐产品
            funcList:[
                {title:'人员管理',content:'对食堂从业人员的培训记录、健康证、晨检等进行管理。'},
                {title:'仓库管理',content:'对食材物资的采购、收货、入库、库存进行管理，并对临期、超期食品、添加剂使用进行分析预警。并提供零星采购管理。'},
                {title:'菜品管理',content:'对食堂的菜单进行管理、审核，根据菜单自动生成每日采购清单。对菜单进行营养分析。'},
                {title:'AI智能监控',content:'实现远程巡检，并可对核心区域进行AI人工视觉智能分析，实现对违规操作的自动预警。'},
                {title:'数据分析',content:'对每日运行数据呈现、分析，食堂运行情况一目了然。'},
            ]
        }
    },
    created(){
        
    },
    mounted(){
		require ("utils/js/amazeui.js");
		// require ("utils/css/amazeui.css");
        this.$nextTick(()=>{
            //头部
            $('.head-contain').scrollspy({
                animation: 'slide-bottom',
                delay: 500,
                repeat: false
            })
            //产品特色
            $('.ul li:nth-child(1)').scrollspy({
                animation: 'slide-left',
                delay: 500,
                repeat: false
            })
            $('.ul li:nth-child(2)').scrollspy({
                animation: 'slide-right',
                delay: 500,
                repeat: false
            })
            $('.ul li:nth-child(3)').scrollspy({
                animation: 'slide-left',
                delay: 500,
                repeat: false
            })
            $('.ul li:nth-child(4)').scrollspy({
                animation: 'slide-right',
                delay: 500,
                repeat: false
            })
            //主要功能
            $('.func').scrollspy({
                animation: 'scale-up',
                delay: 1000,
                repeat: false
            })
        })
	},
}
</script>
<style lang="less" scoped>
@import '../css.less';
</style>